/* eslint-disable unicorn/filename-case */
/* eslint-disable array-callback-return */
/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import _ from 'lodash';
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React, { useCallback, useContext } from "react";
import cx from 'classnames'
import { Flex } from '@jutro/layout'
import { IntlContext, TranslatorContext } from "@jutro/locale";
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { ClausesComponentVM } from 'ent-components-platform-react';
import messages from "twia-capability-quoteandbind-cp-react/components/TWIABuildingSummaryAccordions/TWIABuildingLocationAccordion/TWIABuildingLocationAccordion.messages"
import CommercialBuildingAccordion from "../CommercialBuildingAccordion/CommercialBuildingAccordion";
import styles from '../../BuildingSummaryAccordion.module.scss'
import metadata from './CommercialPolicySummaryDetails.metadata.json';


function CommercialPolicySummaryDetails(props) {

    const { data: currentPeriodDetails, isRenewalSummary = false } = props
    const translator = useContext(TranslatorContext)
    const locations = _.get(currentPeriodDetails, 'lobs.commercialProperty.coverables.locations');
    const intlContext = useContext(IntlContext);
    let totalPremium = _.get(currentPeriodDetails, 'lobs.commercialProperty.totalPremium');

    if (totalPremium && totalPremium.amount) {
        const { amount, currency } = totalPremium
        totalPremium = intlContext.formatNumber(amount, {
            style: 'currency',
            currency,
        });
    } else {
        totalPremium = 0
    }

    // US28766 and US28769
    const updateLocPremium = useCallback((location) => {
        let totalLocationPremium = 0;
        let currency;

        location?.buildings?.map((tp) => {
            totalLocationPremium += tp.premium.amount
            currency = tp.premium.currency
        })

        const formatterCurrency = intlContext.formatNumber(totalLocationPremium, {
            style: 'currency',
            currency,
        });

        return formatterCurrency;
    }, [intlContext])

     const getLocationSummaryHeading_TWIA = useCallback((data) => {
            
            if ( data.isNonSpecificLocation_TWIA) {
                return data.displayNameForNonSpecificLocation_TWIA
            }
            if(!data.isNonSpecificLocation_TWIA) {
                return data.displayName
            }
            return 
        }, [])

    const locationHeader = useCallback((data, name, locPremium) => {
        return (
            <div>
                <Flex className={styles.fullWidth}>
                    <div className={cx(styles.heading, styles.headingBold, styles.flexOneThird)}>{translator(messages.locationHeading)}&nbsp;&nbsp;{_.get(data, 'locationNum_TWIA')}</div>
                    <div className={cx(styles.heading, styles.flexOneThird)}>{getLocationSummaryHeading_TWIA(data)}</div>
                    <div className={cx(styles.heading, styles.flexOneThird, styles.displayPremium)}>{locPremium}</div>
                </Flex>
            </div>
        )
    }, [translator])

    const generateTopicOverrides = useCallback(() => {
        if (locations === undefined) {
            return [];
        }
        const overrides = locations?.map((data, i) => {
            return {
                [`locationCard${i}`]: {
                    title: locationHeader(data, data.displayName, updateLocPremium(data))
                },
                [`buildingsAccordion${i}`]: {
                    isRenewalSummary
                }
            }

        });

        return Object.assign({}, ...overrides);
    }, [isRenewalSummary, locationHeader, locations, updateLocPremium]);

    const resolvers = {
        resolveCallbackMap: {
            updateLocPremium
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
            CommercialBuildingAccordion
        },
    }

    const overrideProps = {
        locationAccordion: {
            data: locations,
        },
        accordion: {
            className: isRenewalSummary ? 'renewalSummary' : 'policySummary noborder'
        },
        buildingsAndLocationsAccordion: {
            title: isRenewalSummary ? translator(messages.coverages) : translator(messages.buildingAndLocation),
            className: isRenewalSummary ? 'accordionTitle bottomBorder' : 'noborder'
        },
        premiumInfo: {
            visible: isRenewalSummary && totalPremium,
            content: translator(messages.premiumInfo, { totalPremium })
        },
        ...generateTopicOverrides()
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={currentPeriodDetails}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default withAuthenticationContext(withRouter(CommercialPolicySummaryDetails));